import Image from 'next/image';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getProductDetail } from '../../../../api-client/my-product';
import { deleteIcon } from '../../../../assets/icons';
import { productImage } from '../../../../public/assets/images';
import Card from '../../../elements/card';

const ProductInfo = ({ setProductInfoModal, productToken }) => {
  const { data, isLoading, status } = useQuery(
    ['product-detail', productToken],
    () => getProductDetail(Number(productToken))
  );

  const details = useMemo(() => data?.data?.data.product, [data]);
  return (
    <section className="h-full w-screen z-50 bg-black flex items-center justify-center fixed top-0 left-0 bg-opacity-40 ">
      <Card className="w-[800px] h-auto">
        <div>
          <div className="flex items-center justify-between">
            <div></div>
            <button onClick={() => setProductInfoModal(false)}>
              <Image src={deleteIcon} alt="Delete |  Stakecut" />
            </button>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-10 items-center justify-items-start md:mt-0 mt-3">
          <div className="md:col-span-1 col-span-3 w-full">
            {isLoading && (
              <div className="animate-pulse h-48 mb-2 w-64 my-2 bg-slate-200"></div>
            )}

            {details && (
              <div className="relative lg:w-64 lg:h-64 h-80 w-80">
                <Image
                  src={details?.image_url || productImage}
                  alt="Stakecut | Details"
                  objectFit="cover"
                  layout="fill"
                />
              </div>
            )}
          </div>

          <div className="col-span-3 md:col-span-2">
            {isLoading && (
              <div>
                <div className="animate-pulse h-6 mb-2 w-96 my-2 bg-slate-200"></div>
                <div className="animate-pulse h-6 w-96 my-2 bg-slate-200"></div>
              </div>
            )}
            {details && (
              <>
                {' '}
                <h2 className="font-medium text-md">{details?.name}</h2>
                <h5 className="text-neutral-mid-60">
                  by {details?.vendorName}
                </h5>
              </>
            )}
            <div></div>
            <div className="mt-5 mb-6">
              {isLoading && (
                <div>
                  <div className="animate-pulse h-6 mb-2 w-96 my-2 bg-slate-200"></div>
                </div>
              )}
              {details && (
                <small>
                  <span className="text-neutral-mid-60">
                    {details?.category} |
                  </span>{' '}
                  {details?.productType}
                </small>
              )}
            </div>

            <div>
              {isLoading && (
                <div>
                  <div className="animate-pulse h-6 mb-2 w-96 my-2 bg-slate-200"></div>
                  <div className="animate-pulse h-6 w-96 my-2 bg-slate-200"></div>
                </div>
              )}

              {details && (
                <p className="text-sm mb-4">{details?.description}</p>
              )}
            </div>
            <div>
              {isLoading && (
                <div>
                  <div className="animate-pulse h-6 mb-2 w-96 my-2 bg-slate-200"></div>
                  <div className="animate-pulse h-6 w-96 my-2 bg-slate-200"></div>
                </div>
              )}
              {details && (
                <>
                  <p className="text-xs">
                    <span className="text-neutral-mid-60">
                      Marketing resource URL: &nbsp;
                    </span>
                    {details?.urls?.marketingResUrl}
                  </p>
                  <p className="text-xs">
                    <span className="text-neutral-mid-60">
                      Product download URL: &nbsp;
                    </span>
                    {details?.urls?.thankYouPageUrl}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </Card>
    </section>
  );
};

export default ProductInfo;
